import {makeAutoObservable} from "mobx";
import {IBonusLevel, IMeta} from "../core/models/Bonuses";

class BonusesLevels {
    [Symbol.toStringTag] = this.constructor.name;
    private _items!: IBonusLevel[];
    private _meta!: IMeta;

    constructor() {
        makeAutoObservable(this);
    }

    get items() {
        return this._items;
    }

    set items(value: IBonusLevel[]) {
        this._items = value;
    }

    get meta() {
        return this._meta;
    }

    set meta(value: IMeta) {
        this._meta = value;
    }
}

export default BonusesLevels;
